<template>
  <span :class="['spinner-border', small && 'spinner-border-sm', `text-${variant}`]" role="status" aria-label="読み込み中"></span>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({ name: 'BSpinner', props: { variant: { type: String, default: 'secondary' }, small: Boolean } })
</script>
